<template>
	<div class="width-full d-flex justify-space-between relative z-3">
		<div v-if="title" class="width-full d-flex align-center py-4 px-6">
			<h3 class="text-title-m" :class="{ 'pr-4': closable }">
				{{ title }}
			</h3>
		</div>
		<div v-if="closable" class="absolute align-self-end top-0 right-0">
			<CloseDialogButton :filled="closeFilled" @click="$emit('cancel')" />
		</div>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		title?: string
		closable?: boolean
		closeFilled?: boolean
	}

	withDefaults(defineProps<Props>(), {
		title: '',
		closable: true,
	})

	defineEmits(['cancel'])
</script>
